import React from "react";
import Slider from "react-slick";
/*---images--- */
import advancedSearch from "../../images/AdvancedSearch.png";
import comparison from "../../images/Comparison.png";
import samples from "../../images/Samples.png";
import equipment from "../../images/Equipment.png";
import dashboard from "../../images/Dashboard.png";
import report from "../../images/Report.png";
import blendCheck from "../../images/BlendCheck.png";
/*---styles--- */
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const CarouselCemTest = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 400,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <Slider {...settings}>
      <div className="carousel-slide">
        <div className="carousel-slide__content">
          <div className="carousel-slide__desc">
            {/* Расширенный поиск */}
            <p className="product__modules-description-header">
              Advanced Search
            </p>
            {/* Модуль обеспечивает эффективный поиск рецептур в базе данных Вашей лаборатории. Введение фильтров и параметров позволяет быстро находить нужные рецептуры, сокращая время поиска до минимума. */}
            <p className="product__modules-description-text">
              The module provides efficient search for formulations in your
              laboratory database. Applying filters and parameters allows quick
              finding of required formulations, reducing search time to a
              minimum.
            </p>
          </div>
          <img src={advancedSearch} alt="slide-1" />
        </div>
      </div>

      <div className="carousel-slide">
        <div className="carousel-slide__content">
          <div className="carousel-slide__desc">
            {/* Сравнение */}
            <p className="product__modules-description-header">Comparison</p>
            {/* Модуль предоставляет возможность анализа и сравнения нескольких рецептур, что позволяет выбрать оптимальный вариант в соответствии с конкретными задачами и требованиями. */}
            <p className="product__modules-description-text">
              The module enables analysis and comparison of multiple
              formulations, allowing selection of the optimal option according
              to specific tasks and requirements.
            </p>
          </div>
          <img src={comparison} alt="slide-2" />
        </div>
      </div>

      <div className="carousel-slide">
        <div className="carousel-slide__content">
          <div className="carousel-slide__desc">
            {/* Пробы */}
            <p className="product__modules-description-header">Samples</p>
            {/* Модуль предоставляет систему учета и логистики всех проб, собранных в лаборатории. <br />
              Это обеспечивает точный и структурированный анализ данных для последующего использования. */}
            <p className="product__modules-description-text">
              The module provides a system for accounting and logistics of all
              samples collected in the laboratory. <br />
              This ensures accurate and structured data analysis for subsequent
              use.
            </p>
          </div>
          <img src={samples} alt="slide-3" />
        </div>
      </div>

      <div className="carousel-slide">
        <div className="carousel-slide__content">
          <div className="carousel-slide__desc">
            {/* Оборудование */}
            <p className="product__modules-description-header">Equipment</p>
            {/* Модуль предоставляет инструменты для учета амортизации и калибровки оборудования в лаборатории. <br />
              Это позволяет эффективно управлять ресурсами и обеспечивать точность получаемых результатов. */}
            <p className="product__modules-description-text">
              The module provides tools for depreciation accounting and
              equipment calibration in the laboratory. <br />
              This enables effective resource management and ensures accuracy of
              obtained results.
            </p>
          </div>
          <img src={equipment} alt="slide-4" />
        </div>
      </div>

      <div className="carousel-slide">
        <div className="carousel-slide__content">
          <div className="carousel-slide__desc">
            {/* Dashboard - остается без перевода, так как это заимствованное слово */}
            <p className="product__modules-description-header">Dashboard</p>
            {/* Модуль предоставляет обобщенную статистику и ключевые показатели на одном экране, обеспечивая оперативный мониторинг и принятие информированных решений. */}
            <p className="product__modules-description-text">
              The module provides summarized statistics and key performance
              indicators on one screen, enabling operational monitoring and
              informed decision-making.
            </p>
          </div>
          <img src={dashboard} alt="slide-5" />
        </div>
      </div>

      <div className="carousel-slide">
        <div className="carousel-slide__content">
          <div className="carousel-slide__desc">
            {/* Отчетность */}
            <p className="product__modules-description-header">Reporting</p>
            {/* Модуль обеспечивает простое и быстрое создание отчетов, предоставляя пользователю гибкие инструменты для форматирования и анализа данных. */}
            <p className="product__modules-description-text">
              The module enables simple and quick report generation, providing
              users with flexible tools for data formatting and analysis.
            </p>
          </div>
          <img src={report} alt="slide-6" />
        </div>
      </div>

      <div className="carousel-slide">
        <div className="carousel-slide__content">
          <div className="carousel-slide__desc">
            {/* BlendCheck - остается без перевода, так как это название модуля */}
            <p className="product__modules-description-header">BlendCheck</p>
            {/* Модуль разработан для обеспечения безошибочной навески в лабораторной среде. Система использует технологию сканирования штрих-кода на пробе, что исключает возможность ошибок при навеске. */}
            <p className="product__modules-description-text">
              The module is designed to ensure error-free weighing in the
              laboratory environment. The system uses barcode scanning
              technology on samples, eliminating the possibility of weighing
              errors.
            </p>
          </div>
          <img src={blendCheck} alt="slide-7" />
        </div>
      </div>
    </Slider>
  );
};

export default CarouselCemTest;
